module.exports = __webpack_public_path__ + "static/media/airtel-logo.0fa079ff.jpg";